import { createEditDraftBlogUrl } from '@confluence/content-utils';

import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalCreateFabricBlogpost: ExperimentalMutations['experimentalCreateFabricBlogpost'] =
	async (_, { spaceKey, title, returnSpaUrl = false }, { network }) => {
		const payload = {
			type: 'blogpost',
			status: 'draft',
			title,
			metadata: {
				properties: {
					editor: {
						value: 'v2',
					},
				},
			},
			space: {
				key: spaceKey,
			},
		};

		const expansions = `space,metadata.frontend.collabService`;

		const response = await network.cfetch(`/wiki/rest/api/content?expand=${expansions}`, {
			method: 'POST',
			headers: {
				Accept: MediaType.JSON,
				'Content-Type': MediaType.JSON,
			},
			body: JSON.stringify(payload),
		});
		const json = await response.json().catch((error) => throwErrorWithResponse(error, response));

		const draftUrl = returnSpaUrl ? createEditDraftBlogUrl(json) : json?._links?.editui;

		if (!draftUrl) {
			throwErrorWithResponse(new Error('Missing content draft url'), response);
		}

		return {
			contentId: json?.id,
			spaceId: json?.space?.id,
			links: {
				draftUrl,
			},
			collabService: json?.metadata?.frontend?.collabService ?? undefined,
		};
	};
